import useIntersectionObserver from '@/hooks/useIntersectionObserver';

const IntersectionObserverWrapper = ({ children }) => {
  const [targetRef, isIntersecting] = useIntersectionObserver({
    threshold: 0.1,
  });
  return <div ref={targetRef}>{isIntersecting && children}</div>;
};

export default IntersectionObserverWrapper;
